import React from 'react';

import SmartLayout from 'application/layout/SmartLayout';

import PointsGroupsPageWrapper, { POINTS_GROUPS_PATH } from 'application/pages/PointsGroupsPage';
import { RouteConfig } from '..';

export const pointsGroupsRoutes: RouteConfig[] = [
  {
    element: <SmartLayout />,
    children: [
      {
        path: POINTS_GROUPS_PATH,
        element: <PointsGroupsPageWrapper />,
      },
    ],
  },
];
